// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as CookiePolicyRouteImport } from './routes/cookie-policy'
import { Route as Contact_psRouteImport } from './routes/contact_ps'
import { Route as Contact_ppcRouteImport } from './routes/contact_ppc'
import { Route as ContactUsRouteImport } from './routes/contact-us'
import { Route as ComplaintsRouteImport } from './routes/complaints'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProductsSlugRouteImport } from './routes/products/$slug'
import { Route as CategorySubCategoryRouteImport } from './routes/$category/$subCategory'
import { Route as ProductsSlugCampaignRouteImport } from './routes/products/$slug_.$campaign'

const CookiePolicyRoute = CookiePolicyRouteImport.update({
            id: '/cookie-policy',path: '/cookie-policy',getParentRoute: () => rootRouteImport
          })
const Contact_psRoute = Contact_psRouteImport.update({
            id: '/contact_ps',path: '/contact_ps',getParentRoute: () => rootRouteImport
          })
const Contact_ppcRoute = Contact_ppcRouteImport.update({
            id: '/contact_ppc',path: '/contact_ppc',getParentRoute: () => rootRouteImport
          })
const ContactUsRoute = ContactUsRouteImport.update({
            id: '/contact-us',path: '/contact-us',getParentRoute: () => rootRouteImport
          })
const ComplaintsRoute = ComplaintsRouteImport.update({
            id: '/complaints',path: '/complaints',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ProductsSlugRoute = ProductsSlugRouteImport.update({
            id: '/products/$slug',path: '/products/$slug',getParentRoute: () => rootRouteImport
          })
const CategorySubCategoryRoute = CategorySubCategoryRouteImport.update({
            id: '/$category/$subCategory',path: '/$category/$subCategory',getParentRoute: () => rootRouteImport
          })
const ProductsSlugCampaignRoute = ProductsSlugCampaignRouteImport.update({
            id: '/products/$slug_/$campaign',path: '/products/$slug/$campaign',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,ComplaintsRoute: ComplaintsRoute,ContactUsRoute: ContactUsRoute,Contact_ppcRoute: Contact_ppcRoute,Contact_psRoute: Contact_psRoute,CookiePolicyRoute: CookiePolicyRoute,CategorySubCategoryRoute: CategorySubCategoryRoute,ProductsSlugRoute: ProductsSlugRoute,ProductsSlugCampaignRoute: ProductsSlugCampaignRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)